export function Stepper({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        className="w-7 h-7 rounded-lg bg-s2 border border-line cursor-pointer inline-flex items-center justify-center"
        onClick={() => onChange(Math.max(0, value - 1))}
      >−</button>
      <input
        type="number"
        min={0}
        value={value}
        onChange={(e) => onChange(Math.max(0, parseInt(e.target.value, 10) || 0))}
        className="serif w-9 text-center text-[20px] bg-transparent border-none outline-none"
        style={{ MozAppearance: 'textfield' } as React.CSSProperties}
      />
      <button
        type="button"
        className="w-7 h-7 rounded-lg bg-s2 border border-line cursor-pointer inline-flex items-center justify-center"
        onClick={() => onChange(value + 1)}
      >+</button>
    </div>
  )
}
